import { CompanySearchRs } from '@domain/rs/pass/interview/company/CompanySearchRs';

export class CompanySearchVO {
  companyList: CompanySearchRs[];

  constructor(rs: CompanySearchRs[]) {
    //openYn === true가 앞으로 오도록 sort
    this.companyList = rs.sort((a, b) => (b.openYn ? 1 : 0) - (a.openYn ? 1 : 0));
  }
}
